import {
  adminModule,
  casino,
  collapseIcon,
  marineMystique,
  sharkDrift,
} from "@/constants";
import { Button } from "../ui/button";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useUserStore from "@/stores/authentication/store";
import useSelfExclusionStore from "@/stores/selfexclusion/store";
import {
  BonusesIcon,
  CaretDown,
  CrashIcon,
  DexIcon,
  DiceIcon,
  InstantIcon,
  LiveIcon,
  MoreIcon,
  NewIcon,
  OriginalGamesIcon,
  PredictionIcon,
  RakebackIcon,
  SlotsIcon,
  StakingIcon,
  TableIcon,
} from "@/assets/icons/ocean/icons";

type SubmenuItem = {
  title: string;
  icon?: any;
  link?: string;
  access?: "admin" | "user" | "guest";
};

type MenuItem = {
  title: string;
  icon: any;
  submenu?: boolean;
  submenuItems?: SubmenuItem[];
  route?: string;
  link?: string;
  access?: "admin" | "user" | "guest";
  comingSoon?: boolean;
};

interface SidebarProps {
  isMobile?: boolean;
  handleCollapse: () => void;
}

const Sidebar = ({ isMobile, handleCollapse }: SidebarProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const userData = useUserStore((state) => state.data);
  const isSelfExclusion = useSelfExclusionStore(
    (state) => state.isSelfExclusion,
  );

  const setOpenPopup = useSelfExclusionStore((state) => state.setOpenPopup);

  const handleNavigationClick = (route: string) => {
    if (isSelfExclusion) {
      setOpenPopup(true);
    } else if (route != "") {
      navigate(route, { replace: true });
      isMobile && handleSidebarCollapse();
    }
  };

  const [menu] = useState<MenuItem[]>([
    {
      title: "Casino",
      icon: DiceIcon,
      submenu: true,
      submenuItems: [
        // {
        //   title: "Sharkroll Originals",
        //   icon: OriginalGamesIcon,
        //   link: "/casino/lobby?tab=original",
        // },
        { title: "Slots", icon: SlotsIcon, link: "/casino/lobby?tab=slots" },
        {
          title: "Instant Games",
          icon: InstantIcon,
          link: "/casino/lobby?tab=instant",
        },
        {
          title: "Live Casino",
          icon: LiveIcon,
          link: "/casino/lobby?tab=liveCasino",
        },

        {
          title: "Table Games",
          icon: TableIcon,
          link: "/casino/lobby?tab=sidebets",
        },
        {
          title: "Crash Games",
          icon: CrashIcon,
          link: "/casino/lobby?tab=battles",
        },
      ],
    },
    {
      title: "Prediction",
      icon: PredictionIcon,
      route: "/prediction-game",
      comingSoon: true,
    },
    { title: "Dex", icon: DexIcon, route: "/shark-dex", comingSoon: true },
    {
      title: "Staking",
      icon: StakingIcon,
      route: "/staking",
      comingSoon: true,
    },
    // {
    //   title: "New on Sharkroll",
    //   icon: NewIcon,
    //   submenu: true,
    //   submenuItems: [
    //     // {
    //     //   title: "Marine Mystique",
    //     //   icon: marineMystique,
    //     //   link: "/games/marine-mystique",
    //     // },
    //     { title: "Shark Drift", icon: sharkDrift, link: "/games/shark-drift" },
    //   ],
    // },
    { title: "Sharkroll Bonuses", icon: BonusesIcon, route: "/bonuses" },
    {
      title: "Cash back",
      icon: RakebackIcon,
      route: "/rakeback-system",
    },
    // {
    //   title: "Maintenance",
    //   icon: MaintenanceIcon,
    //   route: "/maintenance",
    // },
    {
      title: "More",
      icon: MoreIcon,
      submenu: true,
      access: "admin",
      submenuItems: [
        {
          title: "Admin Module",
          icon: adminModule,
          link: "/admin",
          access: "admin",
        },
      ],
    },
  ]);

  const [filteredMenu, setFilteredMenu] = useState<MenuItem[]>([]);

  useEffect(() => {
    const isAdmin = userData?.privileges?.includes(2);
    const filterMenu = (menuItems: any[]) => {
      return menuItems
        .map((item) => {
          if (item.access === "admin" && !isAdmin) {
            return null;
          }

          if (item.submenu) {
            const filteredSubmenuItems = item.submenuItems.filter(
              (subItem: { access: string }) => {
                if (subItem.access === "admin" && !isAdmin) {
                  return false;
                }
                return true;
              },
            );

            return { ...item, submenuItems: filteredSubmenuItems };
          }

          return item;
        })
        .filter(Boolean); // Filter out null values
    };

    const filtered = filterMenu(menu);
    setFilteredMenu(filtered);
  }, [userData, menu]);

  const [openSubmenuIndex, setOpenSubmenuIndex] = useState(null);
  const navigate = useNavigate();

  const toggleSubmenu = (index: any) => {
    setOpenSubmenuIndex(openSubmenuIndex === index ? null : index);
  };

  // handle both mobile & desktop sidebar collapse
  const handleSidebarCollapse = () => {
    if (isMobile && handleCollapse) {
      handleCollapse();
    } else {
      setIsOpen(!isOpen);
    }
  };

  // const setDexActiveTab = useNavigationStore((state) => state.setDexActiveTab);

  // function handleBuyAndSell(): void {
  //   navigate("/shark-dex?tab=trade", { replace: true });
  //   handleSidebarCollapse();
  // }

  // function handleDashboard(): void {
  //   navigate("/shark-dex?tab=buyandburn", { replace: true });
  //   handleSidebarCollapse();
  // }

  // const { data: getAllActiveGames } = useGetAllActiveGames();

  // useEffect(() => {
  //   if (getAllActiveGames?.data) {
  //     const filteredGames = getAllActiveGames?.data?.filter((item: any) => {
  //       if (!isLoggedIn) {
  //         return !item.isCustomGame && item.hasDemo;
  //       } else return !item.isCustomGame;
  //     });

  //     const gamesMenu = filteredGames?.map((game: any) => ({
  //       title: game.name,
  //       icon: casino,
  //       link: `/casino/games/${game.slug}`,
  //     }));

  //     // add games to 1st casino submenu
  //     setMenu((prev) => {
  //       const updatedMenu = [...prev];
  //       updatedMenu[0].submenuItems = gamesMenu;
  //       return updatedMenu;
  //     });
  //   }
  // }, [getAllActiveGames]);

  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <div className="relative z-[45] min-h-screen border-r border-white/10 bg-foreground">
      <div
        className={`${!isMobile && "hidden lg:block"} prevent-select sticky top-0  min-h-screen  px-3 py-4  ${
          isOpen ? "min-w-[252px] " : "min-w-[40px]"
        } relative duration-300`}
      >
        {isOpen ? (
          <div className="shadow mb-8 inline-flex h-[122px] w-full flex-col items-start justify-center rounded-2xl">
            <div className="mt-3 w-full flex-1 rounded-lg bg-background p-1 py-2 text-center font-[Ubuntu] text-[11px] font-[500] text-white ">
              <p>Get in early</p>
              <p>purchase Sharkroll's native currency,</p>
              <p>
                <span className="text-[#00FFC2]">SHRL</span>, during the
                pre-sale!
              </p>
            </div>
            <div className="w-full flex-1 rounded-b-lg bg-primary-background p-1">
              <div className="h-18 w-18 relative m-2 flex items-center">
                <img
                  src="/assets/main/group-icon.png"
                  className="relative z-10"
                />

                <Button
                  onClick={() =>
                    (window.location.href = "https://www.sharkroll.io/")
                  }
                  className="absolute top-1/2 ml-[40px] h-[46px] w-[150px] -translate-y-1/2 bg-button-gradient font-kanit text-lg text-white"
                >
                  Buy Now
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <Button
            onClick={() => (window.location.href = "https://www.sharkroll.io/")}
            className="relative mb-4 mt-6 h-[90px] w-[50px] text-wrap bg-button-gradient p-2 pt-12 font-kanit text-[16px] text-white"
          >
            <img
              src="/assets/main/group-icon.png"
              className="absolute -top-3 z-10"
            />
            Buy now
          </Button>
        )}
        <div className="flex items-center justify-between">
          {/* expand */}
          <Button
            className={`p-2 ${isOpen && "hidden"} mx-2 [background:linear-gradient(180deg,rgba(30,39,255,0.15)_0%,rgba(41,229,255,0.15)_100%)]`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <img
              src={collapseIcon as string}
              alt="expand"
              className="scale min-w-5 rotate-180"
            />
          </Button>

          <span
            className={`text-sm font-bold text-white duration-200 ${isOpen ? "block" : "hidden"}`}
          >
            Main Menu
          </span>

          {/* collapse - handle both desktop & mobile (close drawer) */}
          <Button
            className={`p-2 ${!isOpen && "hidden"} [background:linear-gradient(180deg,rgba(30,39,255,0.15)_0%,rgba(41,229,255,0.15)_100%)]`}
            onClick={handleSidebarCollapse}
          >
            <img
              src={collapseIcon as string}
              alt="collapse"
              className="min-w-5 "
            />
          </Button>
        </div>

        {/* menu items */}
        <ul className="mt-1.5 flex flex-col items-center">
          {filteredMenu.map((item, index) => (
            <li
              key={index}
              className={`relative cursor-pointer border-b-1 py-1.5 ${!isOpen ? "w-2/3" : "w-full"}`}
              onClick={
                !item.comingSoon
                  ? () => handleNavigationClick(item.route || "")
                  : () => {}
              }
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div
                className="flex cursor-pointer items-center justify-between py-2 pr-1"
                onClick={() => item.submenu && toggleSubmenu(index)}
              >
                <div
                  className={`flex w-full flex-row items-center ${!isOpen ? "flex-col gap-2" : "justify-center gap-6"}`}
                >
                  <div className="w-4">{item?.icon("")}</div>
                  <div
                    className={`flex w-full items-center justify-between ${!isOpen && "flex-col"}`}
                  >
                    <span
                      className={`text-sm font-bold text-white/90 duration-200 ${
                        !isOpen && "hidden"
                      }`}
                    >
                      {item.title}
                    </span>
                    {item.comingSoon && (
                      <div
                        className={`bg-primary-background ${isOpen ? "p-1.5" : "p-1 text-center"} text-[10px] font-[500] text-primary-text`}
                      >
                        Coming Soon
                      </div>
                    )}
                  </div>
                </div>
                {item.submenu && isOpen && (
                  <CaretDown
                    className={`w-3 duration-75 ${
                      openSubmenuIndex === index && "rotate-180"
                    }`}
                  />
                )}
              </div>
              {item.submenu && openSubmenuIndex === index && (
                <ul className="mt-1 flex flex-col items-center gap-2">
                  {item.submenuItems?.map((subitem, subindex) => (
                    <li
                      key={subindex}
                      className={`relative cursor-pointer py-1.5 ${!isOpen ? "w-2/3" : "w-full"}`}
                      onClick={() => handleNavigationClick(subitem.link || "")}
                    >
                      <div
                        className={`flex w-full flex-row items-center ${!isOpen ? "flex-col gap-2" : "gap-6"}`}
                      >
                        {typeof subitem.icon === "string" ? (
                          <img
                            src={
                              subitem.icon
                                ? (subitem.icon as string)
                                : (casino as string)
                            }
                            alt="casino"
                            className="w-4"
                          />
                        ) : (
                          subitem.icon && (
                            <div className="w-4">{subitem.icon()}</div>
                          )
                        )}
                        <span
                          className={`text-sm font-bold text-white/90 duration-200 ${!isOpen && "hidden"}`}
                        >
                          {subitem.link ? (
                            <Link to={subitem.link}>{subitem.title}</Link>
                          ) : (
                            <>{subitem.title}</>
                          )}
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
